/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AvailableTimezoneResponse } from '../models/AvailableTimezoneResponse';
import type { TimezoneUpdateRequest } from '../models/TimezoneUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TimezoneRestControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateTimezone({
        requestBody,
    }: {
        requestBody: TimezoneUpdateRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/timezone',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns AvailableTimezoneResponse OK
     * @throws ApiError
     */
    public static getAvailableTimezones(): CancelablePromise<AvailableTimezoneResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/timezone/available',
        });
    }
}
